import type Phaser from 'phaser';
import { overlayPolicyFor } from './overlayPolicy.js';

const OVERLAYS = new Set(['Hud', 'CompanionLayer', 'PhoneOverlay', 'Reward', 'QuestLayer']);
const COMPANION_WORLD_SCENES = new Set([
  'Town',
  'Park',
  'House',
  'HouseBuild',
  'Wardrobe',
  'Shop',
  'Cafe',
  'School',
  'Pool',
  'Stable',
  'Garden',
  'Icecream',
  'Vet',
]);

export function shouldEnsureCompanion(sceneKey: string): boolean {
  return COMPANION_WORLD_SCENES.has(sceneKey);
}

type QuestOfferController = {
  setOfferUiEnabled: (enabled: boolean) => void;
};

/** Nawigacja między scenami — zamrożony helper WP0. */
export class SceneRouter {
  constructor(private readonly game: Phaser.Game) {}

  /** Zatrzymaj wszystkie sceny gry (nie overlay) i wystartuj `key`. */
  go(key: string, data?: object): void {
    const manager = this.game.scene;
    const overlayPolicy = overlayPolicyFor(key);
    for (const overlayKey of overlayPolicy.stop) {
      if (overlayKey !== key && manager.keys[overlayKey]) {
        manager.stop(overlayKey);
      }
    }

    if (manager.isActive('QuestLayer') || manager.isPaused('QuestLayer')) {
      const questLayer = manager.getScene('QuestLayer') as unknown as QuestOfferController;
      questLayer.setOfferUiEnabled(overlayPolicy.questOfferVisible);
    }

    const active = manager.getScenes(true);
    for (const s of active) {
      const k = s.scene.key;
      if (OVERLAYS.has(k)) continue;
      if (k !== key) {
        manager.stop(k);
      }
    }
    // sleep dormant scenes too — unikaj „duchów” z interactive
    for (const k of Object.keys(manager.keys)) {
      if (OVERLAYS.has(k) || k === key) continue;
      const sys = manager.getScene(k)?.scene;
      if (sys && (sys.isActive() || sys.isPaused() || sys.isSleeping())) {
        manager.stop(k);
      }
    }
    manager.start(key, data);
    if (
      shouldEnsureCompanion(key) &&
      !manager.isActive('CompanionLayer') &&
      !manager.isPaused('CompanionLayer')
    ) {
      (manager as unknown as { run: (sceneKey: string) => void }).run(
        'CompanionLayer',
      );
    }
  }

  launchOverlay(key: string, data?: object): void {
    (this.game.scene as unknown as { run: (k: string, d?: object) => void }).run(
      key,
      data,
    );
  }

  stopOverlay(key: string): void {
    this.game.scene.stop(key);
  }
}

let router: SceneRouter | null = null;

export function initSceneRouter(game: Phaser.Game): SceneRouter {
  router = new SceneRouter(game);
  return router;
}

export function getSceneRouter(): SceneRouter {
  if (!router) throw new Error('SceneRouter not init');
  return router;
}
